import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../lib/index';
import API from '../api';


class CreateEvent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            eventCreated: false,
            eventData: {},
            trigger: false,
        };
        this.triggetNext = this.triggetNext.bind(this);
    }

    componentWillMount() {
        const self = this;
        const {steps,store} = this.props;

        const bodyFormData = new FormData();

        let patient_id = store.patient.id;

        bodyFormData.append('services[]', steps.serviceId.value);
        bodyFormData.append('location', steps.location.value);
        bodyFormData.append('destination', steps.slot.value.destination);
        bodyFormData.append('slot', steps.slot.value.slot);
        bodyFormData.append('patient',patient_id);

        API.post(
            '/createEvent',
            bodyFormData,
            { headers: {'Content-Type': 'multipart/form-data' }}).then((res) => {
            const result = res.data;
            // debugger;
            if (result.status == "success") {
                if(result.data.length>0){
                    this.setState(
                        {loading: false,eventCreated:true, eventData: result.data[0]}
                    );
                    self.triggetNext(true,'would_you_like_to_do_something_else');
                }else{
                    this.setState(
                        {loading: false,eventCreated:false}
                    );
                    self.triggetNext(true,'would_you_like_to_do_something_else');
                }

            }
        }).catch((error) => {
            this.setState({
                error: 'Error retrieving data',
                loading: false
            });
        });
    }

    triggetNext(value,trigger) {
        this.setState({trigger: true});
        this.props.triggerNextStep({value:value,trigger: trigger})
    }
    render() {
        const {loading, eventCreated} = this.state;
        const {step} = this.props;

        return (
            <div>
                {loading ? (
                    <Loading/>
                ) : (
                    eventCreated ? (
                        <span>{step.metadata.successMsg}</span>
                    ):(
                        <span>{step.metadata.errorMsg}</span>
                    )
                )}
            </div>
        );
    }

}

CreateEvent.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

CreateEvent.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default CreateEvent;
